import React from 'react';
import { Link } from 'react-router-dom';
import { LockClosedIcon } from '@heroicons/react/24/outline';

interface TicketAccessDeniedProps {
  ticketType: 'Case' | 'Incident' | 'Problem' | 'Change' | 'Service Request';
  ticketNumber?: string;
  listPageUrl: string;
}

const TicketAccessDenied: React.FC<TicketAccessDeniedProps> = ({
  ticketType,
  ticketNumber,
  listPageUrl
}) => {
  return (
    <div className="h-full flex items-center justify-center px-4 py-8">
      <div className="max-w-lg w-full">
        <div className="flex items-center space-x-5">
          {/* Lock Icon */}
          <div className="flex-shrink-0">
            <div className="rounded-full bg-blue-100 p-3">
              <LockClosedIcon className="h-12 w-12 text-blue-500" />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1">
            <h1 className="text-lg font-semibold text-gray-900 mb-1.5">
              You've stumbled on a restricted {ticketType.toLowerCase()}
            </h1>
            <p className="text-sm text-gray-600 mb-3.5">
              There's nothing for you to see here, so let's get you back to where you came from.
              {ticketNumber && (
                <span className="text-gray-500"> ({ticketType} {ticketNumber})</span>
              )}
            </p>

            {/* Buttons */}
            <div className="flex items-center space-x-2">
              <Link
                to={listPageUrl}
                className="inline-flex items-center px-3.5 py-1.5 border border-transparent text-sm font-medium rounded shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
              >
                Previous page
              </Link>
              <Link
                to="/"
                className="inline-flex items-center px-3.5 py-1.5 border border-gray-300 text-sm font-medium rounded shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
              >
                Go home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketAccessDenied;
